'use strict';

import $ from 'jquery';

export default class InitiativesGrid {
  constructor() {

    const $grid = $('.grid');

    let page = 1;

    $('*[data-js="loadMoreGridElements"]').on('click', (event) => {
      event.preventDefault();
      $(event.delegateTarget).parent().addClass('loading');
      const url = $(event.delegateTarget).attr('data-src-url');
      $.ajax({
        url: url,
        crossDomain: true,
        crossOrigin: true,
        data : {
          page : page
        },
        dataType : 'json',
        success : (res) => {
          page++;
          let $items = $(res.items);
          if ( page >= res.pages ) {
            $(event.delegateTarget).parent().fadeOut('200', () => {
              $(event.delegateTarget).parent().remove();
            });
          }
          $grid.append($items);
          
          $(event.delegateTarget).parent().removeClass('loading');
        }
      });
    });
  }
}
